import React, { useEffect } from "react";

import LandingPageHeader from "../components/headers/LandingPageHeader";
import LandingPageContent from "../components/content/LandingPageContent";
import LandingPageNavbar from "../components/navbars/LandingPageNavbar";

import Target from "../components/content/Target";
import CarouselSection from "../components/content/Slider";

import Gallery from "../components/content/Gallery";

import Sponsors from "../components/content/Sponsors";
// import SiteFooter from "../components/footers/SiteFooter";

// Core Components
import PageNavbar from "../components/navbars/PageNavbar";
import SiteFooter from "../components/footers/SiteFooter";

const LandingPage = () => {
  return (
    <>
      <PageNavbar />
      <div className="wrapper">
        <Gallery />
        <SiteFooter />
      </div>
    </>
  );
};

export default LandingPage;
